import { translate } from 'services/i18nService';


export enum RegistrationModalCaller {
  CHAT_SETTINGS = 'CHAT_SETTINGS',
  DESKTOP_TIP_BAR = 'DESKTOP_TIP_BAR',
  SHOW_INTERACTION_BUTTONS = 'SHOW_INTERACTION_BUTTONS',
  EMAIL_EXISTS_MODAL = 'EMAIL_EXISTS_MODAL',
  HEADER = 'HEADER',
  GUEST_MENU = 'GUEST_MENU',
  HEADER_MAIN = 'HEADER_MAIN',
  HEADER_MAIN_24_HOUR = 'HEADER_MAIN_24_HOUR',
  HEADER_PRIVATE_MESSAGE = 'HEADER_PRIVATE_MESSAGE',
  HEADER_REGISTRATION = 'HEADER_REGISTRATION',
  LEFT_MOBILE_MENU = 'LEFT_MOBILE_MENU',
  MOBILE_PROFILE_ADD_FRIENDS = 'MOBILE_PROFILE_ADD_FRIENDS',
  SFW_OVERLAY = 'SFW_OVERLAY',
  UPGRADE_DRAWER = 'UPGRADE_DRAWER',
  UPGRADE_DRAWER_PS = 'UPGRADE_DRAWER_PS',
  BROADCATING_INFO = 'BROADCATING_INFO',
  BUY_TOKENS_MODAL = 'BUY_TOKENS_MODAL',
  DIRECTORY = 'DIRECTORY',
  APPLIED_FILTERS = 'APPLIED_FILTERS',
  PRE_LANDER = 'PRE_LANDER',
  DESKTOP_BROADCAST = 'DESKTOP_BROADCAST',
  DESKTOP_BROADCAST_REPEAT = 'DESKTOP_BROADCAST_REPEAT',
  DESKTOP_BROADCAST_USER_LIST = 'DESKTOP_BROADCAST_USER_LIST',
  PROFILE_BANNER_LOGIN = 'PROFILE_BANNER_LOGIN',
  PROFILE_BANNER_ADD_TO_FAVORITES = 'PROFILE_BANNER_ADD_TO_FAVORITES',
  PROFILE_BANNER_FAVORITE_BUTTON = 'PROFILE_BANNER_FAVORITE_BUTTON',
  PROFILE_BANNER_FRIEND_BUTTON = 'PROFILE_BANNER_FRIEND_BUTTON',
  MOBILE_CHAT = 'MOBILE_CHAT',
  CHAT_MOBILE_MESSAGES = 'CHAT_MOBILE_MESSAGES',
  STUDIO_INVITATION = 'STUDIO_INVITATION',
  EARNING_TOKENS = 'EARNING_TOKENS',
  REGISTRATION_FORM = 'REGISTRATION_FORM',
  FAVORITES = 'FAVORITES',
  FRIENDS = 'FRIENDS',
  INBOX_MESSAGE = 'INBOX_MESSAGE',
  PROFILE = 'PROFILE',
}

export const getRegistrationTitle = (
  registrationModalCaller: RegistrationModalCaller,
  username: String
): ReturnType<typeof translate> => {
  if (!username) {
    return translate('gold.gold.join.for.free.new');
  }
  switch (registrationModalCaller) {
    case RegistrationModalCaller.PROFILE_BANNER_FAVORITE_BUTTON:
    case RegistrationModalCaller.PROFILE_BANNER_ADD_TO_FAVORITES:
      return translate('profile.registration.form.title.add.favorite', { 0: username });
    case RegistrationModalCaller.MOBILE_PROFILE_ADD_FRIENDS:
    case RegistrationModalCaller.PROFILE_BANNER_FRIEND_BUTTON:
      return translate('profile.registration.form.title.add.friend', { 0: username });
    case RegistrationModalCaller.CHAT_MOBILE_MESSAGES:
    case RegistrationModalCaller.MOBILE_CHAT:
    case RegistrationModalCaller.CHAT_SETTINGS:
    case RegistrationModalCaller.PROFILE:
      return translate('profile.registration.form.title.chat', { 0: username });
    case RegistrationModalCaller.INBOX_MESSAGE:
    case RegistrationModalCaller.HEADER_PRIVATE_MESSAGE:
      return translate('profile.registration.form.title.inbox', { 0: username });
    default:
      return translate('gold.gold.join.for.free.new');
  }
};
